import React, { useMemo } from "react";
import articles from "../articles.json";

const clampStyle = (lines) => ({
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: lines,
  overflow: "hidden",
});

function stripHtml(html = "") {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}
function formatDate(d) {
  if (!d) return "";
  const m = d.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return d;
  const [_, dd, mm, yyyy] = m;
  const date = new Date(`${yyyy}-${mm}-${dd}T00:00:00Z`);
  if (isNaN(date)) return d;
  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function formatTickers(t) {
  if (!t) return "";
  if (Array.isArray(t)) return t.map((x) => String(x).toUpperCase()).join(", ");
  return String(t).toUpperCase();
}
const Flair = ({ children }) => (
  <span
    style={{
      fontSize: 11,
      fontWeight: 600,
      padding: "4px 8px",
      borderRadius: 999,
      background: "#eef0ff",
      color: "#3b33ff",
      border: "1px solid #dfe2ff",
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </span>
);

const ArticleList = ({ count = 5 }) => {
  const latestArticles = useMemo(
    () => [...articles].sort((a, b) => b.id - a.id).slice(0, count),
    [count]
  );

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflowY: "auto",
        background: "white",
      }}
    >
      <ul
        role="list"
        style={{
          listStyle: "none",
          margin: 0,
          padding: 0,
          display: "grid",
          paddingTop: 12,
          gap: 12,
        }}
      >
        {latestArticles.map((article) => {
          const plain = stripHtml(article.content);
                    const dateStr = formatDate(article.date);
          const tickers = formatTickers(article.tickersMentioned);
           const metaLine = [dateStr, tickers].filter(Boolean).join(" | ");
          return (
            <li
              key={article.id}
              style={{
                padding: "0px 12px",
                
                background: "#fff",
              }}
            >
              <a
                href={article.url}
                style={{
                  display: "flex",
                  gap: 12,
                  textDecoration: "none",
                  color: "inherit",
                  alignItems: "flex-start",
                }}
              >
                <img
                  src={article.image}
                  alt=""
                  style={{
                    width: 108,
                    height: 92,
                    objectFit: "cover",
                    borderRadius: 8,
                    flex: "0 0 auto",
                  }}
                  loading="lazy"
                />
                <div style={{ minWidth: 0 }}>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: 14,
                      fontWeight: 500,
                      textAlign : "left",
                      fontFamily: "Poppins",
                      ...clampStyle(2),
                    }}
                    title={article.title}
                  >
                    {article.title}
                  </h3>
                  <div
                      style={{
                        
                        fontSize: 10,
                        color: "#616161",
                        fontWeight: 400,
                        textAlign : "left",
                        ...clampStyle(1),
                      }}
                    >
                      {metaLine}
                    </div>
                  <p
                    style={{
                      margin: "6px 0 0",
                      fontSize: 12,
                      lineHeight: 1.4,
                      textAlign : "left",
                      color: "#444",
                      ...clampStyle(3), // ≈ 3–4 lines
                    }}
                    title={plain}
                  >
                    {plain}
                  </p>
                </div>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ArticleList;
